// Vendors
import type { FormatDateOptions } from 'react-intl';
// Constants
import { AMAZON_DOMAIN, API_AMAZON_DOMAIN } from './customers.constants';

export const MONTH_YEAR_DATE_NUMERIC_FORMAT = {
  month: '2-digit',
  year: 'numeric',
} as FormatDateOptions;

export default {
  AMAZON_DOMAIN,
  API_AMAZON_DOMAIN,
  DEMO_ENVIRONMENTS: ['demo', 'demo-cc'],
  DEMO_URL: `https://app.demo.wp.${AMAZON_DOMAIN}/amazon`,
  DEV_ENVIRONMENTS: ['dev', 'dev-cc'],
  DEV_URL: `https://app.dev.wp.${AMAZON_DOMAIN}/amazon`,
  DICTIONARY: 'dictionary',
  ENVIRONMENTS: ['dev', 'stg', 'qa', 'dev-cc', 'qa-cc', 'stg-cc', 'demo', 'demo-cc'],
  HOST_NAME: '127.0.0.1',
  LOCALHOST_REGEX: /localhost/,
  LOCALHOST_URL: 'http://localhost:8080',
  PROD_URL: `https://${AMAZON_DOMAIN}/amazon`,
  SESSION_ID: 'sessionId',
  STG_ENVIRONMENTS: ['stg', 'stg-cc'],
  STG_URL: `https://app.stg.wp.${AMAZON_DOMAIN}/amazon`,
  AMAZON_PUBLIC_SITE_FAQS: 'https://www.openbankpay.com/de/amazon/hilfe/',
  AMAZON_PUBLIC_SITE: 'https://www.openbankpay.com/de/amazon',
};
